import { DIMBO_CONSTANT } from './../utils/constant';
import { CacheService } from './cache.service';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../app.config';

@Injectable()
export class SetTokenInterceptorService implements HttpInterceptor {

    constructor( private cacheService: CacheService, private appConfig:AppConfig) {

    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
        const issuerUrl = this.appConfig.issuerURL || '';
        let issuerHostPath = '';

        try {
            const urlObj = new URL(issuerUrl);
            issuerHostPath = `/${urlObj.hostname}`;
        } catch {
            // Fallback: simple parse if URL constructor fails
            const match = issuerUrl.match(/^https?:\/\/([^:/]+)/i);
            issuerHostPath = match ? `/${match[1]}` : '';
        }

        if (issuerHostPath && request.url.includes(issuerHostPath)) {
            return next.handle(request);
        }
        
        const jwt_token = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_TOKEN);

        request = request.clone({
            setHeaders: {
                authorizationToken: `Bearer ${jwt_token}`,
                'Content-Type': 'application/json'
            }
        });
      
        return next.handle(request);
    }
}


/* provider: [{
provide: HTTP_INTERCEPTORS,
useClass: SetWithCredentialsHeaderInterceptor, multi: true
} ] */
 
